import React from "react";
import { join, map } from "lodash";
import { getMetricLabel } from "@linkfluence/i18n";
import { Metric } from "@linkfluence/models/metric";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

export default function SharedCardsSubtitleMetrics({
  metrics,
}: {
  metrics: Metric[];
}) {
  const locale = useCurrentUserLocale();
  return (
    <>
      {join(
        map(metrics, (metric) => getMetricLabel(locale, metric)),
        ", "
      )}
    </>
  );
}
